export const SUMMER_CROPS = {
  favaBeanSummer: "bf02e1a9-8fc9-4ed0-b069-17460edb867d",
  peaSummer: "87dd97ad-de8a-4aaf-ab82-c74826f61011",
  potatoes: "ee5d825e-5e7d-478e-bc93-9b762c7360ae",
  cornGrain: "493e3513-88e7-49e4-8509-3843d77882b2",
  // For some reason there are a few similar silage corns
  silageMaize: "8c40e899-8485-4e18-9ed4-d161fad7488d",
  cornSilage: "2c6893bb-8d76-4a1d-a855-85eb56c8145b",
  mixtureWithSilageMaize: "ef5a4ab1-1a4d-4350-aa72-b46e417014d3",
  soybeans: "7153e8d4-73d7-45cd-bc12-62737e3929fe",
  springBarley: "4f8bfe44-2103-4e70-9088-53c5ddce2008",
  summerOats: "15b8a95c-6231-47e6-9022-4eafeb4e0786",
  ryeSummer: "65d06947-3e8c-4839-a707-b1b646f8be5a",
  wheatSpring: "693e37be-5455-4a73-a290-2fdbf4d43ebe",
  sunflowers: "25cfaa8f-2246-468f-bceb-1739d78d28a8",
  beetSugar: "99beb3e1-2622-4ab2-9827-403c261a8b66",
} as const;
